import { render, staticRenderFns } from "./ContratoAssinado.vue?vue&type=template&id=61b314d0&"
import script from "./ContratoAssinado.vue?vue&type=script&lang=js&"
export * from "./ContratoAssinado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContratoAssinado.vue"
export default component.exports